<div class="form-field-wrapper mb-4">
  <label class="form-field-label">
    <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
    {{ label }}
  </label>
  <div class="input-group form-input-group w-100">
    <input
      class="form-field form-field__datepicker flex-grow-1"
      [placeholder]="placeholder | translate"
      [ngClass]="{ 'input-required': errorText }"
      [formControl]="formControl"
      name="dp-range"
      bsDaterangepicker
      [bsConfig]="bsConfig"
      autocomplete="off"
    >

    <button class="btn btn-outline-secondary calendar calendar-button" type="button">
      <i class="bi bi-calendar-check"></i>
    </button>

    <span *ngIf="errorText" class="form-field-info required-label">{{ errorText | translate }}</span>
    <span *ngIf="infoText && !errorText" class="form-field-info">{{ infoText }}</span>
  </div>
</div>

